const AmyMode = {
  FullBody: 'fullBody',
  HalfBody: 'halfBody',
  Avatar: 'avatar',
};

export default AmyMode;
